import { ConsumptionTypeAdditionalData, ConsumptionTypeInterface } from './consumption-type.interface';
import { SolarCalculatorRequest } from '../../../../models/analysis/solar-calculator-request';
import { ConsumptionType } from '../../../../../services/analysis.service';
import { SolarCalculatorConsumption } from '../../../../models/analysis/solar-calculator-consumption';

export class MonthlyConsumptionType implements ConsumptionTypeInterface {
  getConsumptionType(): ConsumptionType {
    return ConsumptionType.MONTHLY;
  }

  setRequestData(request: SolarCalculatorRequest, formValue: any, additionalData?: ConsumptionTypeAdditionalData) {
    const consumptionInput: number[] = formValue.consumption;
    let consumption: SolarCalculatorConsumption[] = [];
    if (additionalData?.tariffHasTwoPrices) {
      for (let i = 0; i < consumptionInput.length; i += 2) {
        consumption.push({ lower: consumptionInput[i], higher: consumptionInput[i + 1] });
      }
    } else {
      consumption = consumptionInput.map((value) => ({ combined: value }));
    }
    request.consumption = consumption;
  }

}
